export { Carousel as Collection, CarouselDisplay as CollectionDisplay, } from './collection';
export { Carousel as Standard } from './standard';
//# sourceMappingURL=index.js.map